import React from 'react';
import {Show} from '../Utils';
import PropTypes from 'prop-types';

import './msg-screen.scss';

export default class MsgScreen extends React.Component {

  constructor({open}) {
    super();

    this.state = {
      open: Boolean(open),
    };
  }

  componentWillReceiveProps({open}) {
    this.setState({open: Boolean(open)});
  }

  render() {
    return (
      <Show condition={this.state.open}>
        <section className="msg-screen">
          <div className="msg-screen__content">
            {this.props.children}
          </div>
        </section>
      </Show>
    );
  }

}

MsgScreen.propTypes = {
  open: PropTypes.bool,
};
